<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section>
            <div class="card">
                <div class="card-header d-none">
                    <label class="form-label">Search Products<span class="text-danger">*</span></label>
                </div>
                <div class="card-body p-1">
                    <ng-autocomplete #auto #ngAutoCompleteStatic [data]="allProduct" name="products" [initialValue]="" [minQueryLength]="3" placeholder="{{ 'SEARCH_PRODUCT' | translate }}" [searchKeyword]="keywordProduct" historyIdentifier="allProduct" [historyHeading]="historyHeading"
                        [historyListMaxNumber]="3" notFoundText="Not found" (selected)='selectEventProduct($event)' (inputChanged)='onChangeSearchProduct($event)' (inputFocused)='onFocusedProduct($event)' [itemTemplate]="itemTemplateStaticProduct" [isLoading]="isLoadingProduct"
                        [notFoundTemplate]="notFoundTemplateProduct">
                    </ng-autocomplete>
                    <ng-template #itemTemplateStaticProduct let-items>
                        <a [innerHTML]="items.full_name"></a>
                    </ng-template>
                    <ng-template #notFoundTemplateProduct let-notFound>
                        <div [innerHTML]="notFound"></div>
                    </ng-template>
                </div>
            </div>
            <div class="ecommerce-application" *ngIf="order_details?.length != 0">
                <section class="row">
                    <div class="col-md-6 col-xs-12" *ngFor="let detail of order_details; let ndx = index">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-3 col-3">
                                        <img class="img-fluid card-img-top m-auto" *ngIf="detail.product_photo != ''" src="{{detail.product_photo}}" alt="img-placeholder" style="max-width: 100px;" />
                                        <img class="img-fluid card-img-top m-auto" *ngIf="detail.product_photo == ''" src="assets/images/no-img.png" alt="img-placeholder" style="width: 100px; opacity: 0.2;" />
                                    </div>
                                    <div class="col-md-6 col-9">
                                        <span *ngIf="detail.category_name != ''">{{detail.category_name}}<br/></span>
                                        <span>{{detail.product_code}} {{detail.product_name}}</span><br/>
                                        <span *ngIf="detail.dispaly_price > 0">₹ {{detail.dispaly_price}} <del class="text-danger">₹ {{detail.sales_price}}</del></span><br/>
                                        <span *ngIf="detail.dispaly_price == 0">₹ {{detail.sales_price}} </span><br/>
                                        <span *ngIf=" detail.size_title != '' || detail.color_title != '' ">
                                            <span *ngIf="detail.size_title != '' ">Size : {{detail.size_title}}</span>
                                        <span *ngIf="detail.color_title != '' ">, &nbsp;Color : {{detail.color_title}}</span>
                                        <br/>
                                        </span>

                                        <span *ngIf="detail.packing_qty> 0 || detail.master_packing_qty > 0">
                                            <span *ngIf="detail.packing_qty > 0">Packing Qty : {{detail.packing_qty}}</span>
                                        <span *ngIf="detail.master_packing_qty > 0">, &nbsp; Master Packing Qty : {{detail.master_packing_qty}}</span>
                                        <br/>
                                        </span>

                                        <span *ngIf="detail.unit != '' && detail.unit != 'null'">Unit : {{detail.unit}}<br/></span>
                                        <div class="badge badge-light-danger" (click)="productDelete(detail.id)" rippleEffect><i class="fa mr-25 fa-trash"></i> {{ 'REMOVE' | translate }}</div>
                                    </div>
                                    <div class="col-md-3 col-12 text-right">
                                        <core-touchspin *ngIf="detail.qty && detail.qty > 0" [numberValue]="detail.qty" size="lg" [stepValue]="detail.min_order_qty" [minValue]="1" [maxValue]="1000" (onChange)="countChange($event,detail.id)"></core-touchspin>
                                        <core-touchspin *ngIf="!detail.qty" [numberValue]="1" size="lg" [stepValue]="detail.min_order_qty" [minValue]="1" [maxValue]="1000" (onChange)="countChange($event,detail.id)"></core-touchspin>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div class="card">
                        <div class="card-body">
                            <form name="form" [formGroup]="newForm" autocomplete="off">
                                <div class="row">
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <textarea formControlName="remarks" class="form-control" rows="4" id="remarks" placeholder="{{ 'REMARK_IF' | translate }}"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="row">
                                            <div class="col-12 col-md-6 pt-2 d-none d-sm-block text-right ">
                                                <div class="form-group  pt-2  text-right">&nbsp;</div>
                                                <button class="btn btn-danger" (click)="removeAll()" *ngIf="total_qty > 0">{{ 'CLEAR_ALL' | translate }}</button>
                                            </div>
                                            <div class="col-12 col-md-6 pt-2 d-none d-sm-none text-right ">

                                            </div>

                                            <div class="col-12  col-md-6 pt-2 text-right ">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form-group  pt-2  text-right">
                                                            <span *ngIf="total_qty > 0"> {{ 'TOTAL_QTY' | translate }} : {{total_qty}}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-6 text-right">
                                                        <button class="btn btn-danger mr-1 d-block d-sm-none" (click)="removeAll()" *ngIf="total_qty > 0">{{ 'CLEAR_ALL' | translate }}</button>
                                                    </div>
                                                    <div class="col-6 text-right">
                                                        <button class="btn btn-primary" [disabled]="loading" (click)="storeDealerOrder()" *ngIf="total_qty > 0">  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> {{ 'SUBMIT' | translate }}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
            <div class="ecommerce-application" *ngIf="order_details?.length == 0">
                <section class="row">
                    <div class="col text-center p-3">
                        <i data-feather="info" [size]="35"></i>
                        <h3 class="pt-2">{{ 'ORDER_LIST_AVAILABLE_ONCE_YOU' | translate }}</h3>
                    </div>
                </section>
            </div>
        </section>
    </div>
</div>